<script setup>
import { ref, watch } from 'vue';

// eslint-disable-next-line no-undef
const props = defineProps({
    label: {
        type: String,
        required: false,
    },
    required: {
        type: Boolean,
        required: false,
    },
    name: {
        type: String,
        default: 'checkbox-options',
    },
    options: {
        type: Array,
        default: () => [],
    },
    modelValue: {
        type: String,
        default: '',
    },
});

// eslint-disable-next-line no-undef
const emit = defineEmits(['update:modelValue']);

const selectedOption = ref(props.modelValue);
watch(() => props.modelValue, (newVal) => {
    selectedOption.value = newVal;
});
watch(selectedOption, (newVal) => {
    emit('update:modelValue', newVal);
});
</script>

<template>
    <div class="tw-flex tw-flex-col tw-gap-8 tw-justify-end">
        <label v-if="props.label" class="!tw-text-[1.2em] tw-font-semibold">
            {{ props.label }}
            <span v-if="props.required" class="tw-text-red-700">*</span>
        </label>
        <div v-if="props.options.length > 0" class="tw-flex tw-flex-col tw-gap-4">
            <div
                v-for="(option, index) in props.options"
                :key="index"
                class="tw-flex tw-items-start tw-pl-4 tw-gap-x-2"
            >
                <Checkbox
                    v-model="selectedOption"
                    :inputId="`option${index}`"
                    :name="props.name"
                    :value="option"
                />
                <div class="tw-ml-2" v-html="option"></div>
            </div>
        </div>
        <div v-else class="tw-flex tw-items-start tw-gap-x-2 tw-pl-4">
            <Checkbox v-model="selectedOption" binary />
            <div class="tw-ml-2">
                <slot />
            </div>
        </div>
    </div>
</template>
